export function initScrollDirection() {
	let lastScrollY = window.scrollY;
	let ticking = false;
	let currentDirection = null;
	const MIN_SCROLL_Y = 120;

	function updateScrollDirection() {
		const scrollY = window.scrollY;
		const direction = scrollY > lastScrollY ? "down" : "up";
		const htmlEl = document.documentElement;

		// Gestione della classe per la parte alta della pagina
		if (scrollY <= MIN_SCROLL_Y) {
			htmlEl.classList.add("scrolling-top");
		} else {
			htmlEl.classList.remove("scrolling-top");
		}

		// Scroll verso il basso
		if (
			direction === "down" &&
			scrollY > MIN_SCROLL_Y &&
			currentDirection !== "down"
		) {
			htmlEl.classList.add("scrolling-down");
			htmlEl.classList.remove("scrolling-up");
			currentDirection = "down";
		}

		// Scroll verso l'alto
		if (direction === "up" && currentDirection !== "up") {
			htmlEl.classList.add("scrolling-up");
			htmlEl.classList.remove("scrolling-down");
			currentDirection = "up";
		}

		lastScrollY = scrollY;
		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			requestAnimationFrame(updateScrollDirection);
			ticking = true;
		}
	}

	window.addEventListener("scroll", onScroll, { passive: true });
}
